<template>
  <div class="flex h-160 w-full flex-col justify-center">
    <slot />
  </div>
</template>
